const setActiveArtwork = (artwork) => {
    return {
        type: 'SET_BOTH_ARTWORK',
        payload: artwork
    };
};

const setLeftArtwork = (artwork) => {
    return {
        type: 'SET_LEFT_ARTWORK',
        payload: artwork
    };
};

const setRightArtwork = (artwork) => {
    return {
        type: 'SET_RIGHT_ARTWORK',
        payload: artwork
    };
};

const setURLToCustomArtwork = (response) => {
    return {
        type: 'SET_URL_TO_ARTWORK',
        payload: response
    };
};
// eslint-disable-next-line
export default {
    setActiveArtwork,
    setLeftArtwork,
    setRightArtwork,
    setURLToCustomArtwork
};
